import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Video Overlays">
        <EuiText>
          <p>
            Stellen Sie den Namen Ihrer Kamera ein und zeigen Sie sie im Videostream an. Fügen Sie dem Video einen Zeitstempel hinzu.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

